import { RouteLocationNormalized } from 'vue-router'

export default {
  routes: [
    {
      name: 'taxonomyTerms',
      path: '/admin/taxonomy2/:uuid/terms/add',
      component: () => import('./views/TheTerms.vue'),
    },
    {
      name: 'taxonomyTerm',
      path: '/admin/taxonomy2/:taxonomyUuid/terms/:uuid',
      component: () => import('./views/TheTerm.vue'),
    },
    {
      path: '/admin/taxonomy2/:uuid/terms/:uuidTerms/edit',
      redirect: '/admin/taxonomy2/:uuid/terms/:uuidTerms?tab=edit',
    },
    {
      path: '/admin/taxonomy2/:uuid/terms',
      redirect: (to: RouteLocationNormalized) => {
        if (to.query.tab === 'add') {
          return {
            path: `/admin/taxonomy2/${to.params.uuid}/terms/add`,
            query: {}
          }
        }
      },
    }
  ]
}
